
import { Injectable, EventEmitter } from '@angular/core';
import { Order } from '../../models/order.model';
import { Customer } from '../../models/customer.model';
import { CartItem } from '../../models/cart-item.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CheckoutService {
  private orderInProgress: Order;
  public orderInProgressChanged: EventEmitter<Order> = new EventEmitter<Order>();
  public stepChanged: EventEmitter<number> = new EventEmitter<number>();
  public activeStep: number;
  private activeStepSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);


  constructor() {
    this.orderInProgress = new Order(new Customer());
    this.activeStep = 0;
  }

  public gotoStep(number) {
    this.activeStep = number;
    this.stepChanged.emit(this.activeStep);
  }

  public nextStep() {
    this.activeStep++;
    this.stepChanged.emit(this.activeStep);
  }
  public prevStep() {
    this.activeStep--;
    this.stepChanged.emit(this.activeStep);
  }

  previousStep() {
    this.activeStep--;
    this.stepChanged.emit(this.activeStep);
  }

  public resetSteps() {
    this.activeStep = 0;
  }

  public setCustomer(customer: Customer) {
    this.orderInProgress.customer = customer;
    this.orderInProgressChanged.emit(this.orderInProgress);
  }

  public setShippingMethod(shippingMethod: string) {
    this.orderInProgress.shippingMethod = shippingMethod;
    this.orderInProgressChanged.emit(this.orderInProgress);
  }

  public setOrderItems(items: CartItem[]) {
    this.orderInProgress.items = items;
    this.orderInProgressChanged.emit(this.orderInProgress);
  }

  public getOrderInProgress() {
    return this.orderInProgress;
  }

  public setPaymentMethod(paymentMethod: string) {
    this.orderInProgress.paymentMethod = paymentMethod;
    this.orderInProgressChanged.emit(this.orderInProgress);
  }


  setActiveStep(step: number) {
    this.activeStep = step;
    this.activeStepSubject.next(step);
  }
}


/*
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  private activeStepSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public stepChanged: Observable<number> = this.activeStepSubject.asObservable();
  public activeStep: number = 0;

  setActiveStep(step: number) {
    this.activeStep = step;
    this.activeStepSubject.next(step);
  }
}
*/
